module.exports = __webpack_public_path__ + "static/image1-fa02dfd779dee337c7a6283fc1ed4214.jpg";